// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1nM7j","title":"ClientInsurance_title__1PlQn","itemText":"ClientInsurance_itemText__1sajj"};